














import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import TargetMixin, {
  GET_GRP_TARGET_POPULATIONS,
} from "@/mixins/http/Grp/Target";
import { Getter } from "vuex-class";

@Component
export default class Disclaimer extends Mixins(TargetMixin) {
  @Prop({ default: "" }) readonly targetId!: string;
  @Prop({ default: "" }) readonly start!: string;
  @Prop({ default: "" }) readonly end!: string;
  @Getter("http/status") readonly status!: { [key: string]: any };

  population = 0;
  loading = false;
  filter = {
    id: "",
    start: "",
    end: "",
  };

  @Watch("targetId")
  async onTargetChanged(value: string) {
    this.filter.id = value;
    await this.load();
  }

  @Watch("start")
  async onStartChanged(value: string) {
    this.filter.start = value;
    await this.load();
  }

  @Watch("end")
  async onEndChanged(value: string) {
    this.filter.end = value;
    await this.load();
  }

  async created() {
    this.filter = {
      id: this.targetId,
      start: this.start,
      end: this.end,
    };
    await this.load();
  }

  async load() {
    if (
      this.filter.id === "" ||
      this.filter.start === "" ||
      this.filter.end === ""
    ) {
      return;
    }
    this.loading = true;
    await this.getTargetPopulation(this.filter);
    this.population = this.status[GET_GRP_TARGET_POPULATIONS].meta.population;
    this.loading = false;
  }
}
